import React from 'react';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { StatisticsPageDesktop } from './StatisticsPage.Desktop';

/**
 * Statistics Page - Shows trading statistics and performance metrics
 * Desktop only - redirects mobile users
 */
export const StatisticsPage: React.FC = () => {
  const isDesktop = useMediaQuery('(min-width: 768px)');

  // Desktop only page
  if (!isDesktop) {
    return (
      <div className="min-h-screen bg-primary flex items-center justify-center p-4">
        <div className="text-center">
          <h1 className="text-xl font-bold text-text-primary mb-2">
            Desktop Only
          </h1>
          <p className="text-text-secondary">
            Statistics page is only available on desktop devices.
          </p>
        </div>
      </div>
    );
  }

  return <StatisticsPageDesktop />;
};
